import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Collapse from 'react-bootstrap/Collapse';

import "./Project3.css"


import RNN from "../../Images/Earsketch-pictures/RNN.png"
import RNN_model from "../../Images/Earsketch-pictures/RNN_model.jpg"
import sentences from "../../Images/Earsketch-pictures/Sentences.png"



const Project3 = () => {

    const [open, setOpen] = useState(false);
    
    return (

        <div className="NumberSystems container col-lg-10 col-md-10 col-sm-4">

            {/* Header */}
            <div className="header">
                <h1>Project 3: Neural Network Language Model</h1>
                <Button onClick={() => setOpen(!open)} aria-controls="example-collapse-text" aria-expanded={open}>
                    Click to expand!
                </Button>
            </div>

            {/* Actual content */}
            <Collapse in={open}>
                <div className='NumberSystem-content'>
                    <h2 className='mt-5'>"Given random Wikipedia articles, attempt to generate a sentence"</h2>
                    <img src={RNN} className="w-50 p-5" alt=""></img>
                    <img src={RNN_model} className="w-50 p-5" alt=""></img>
                    <p>RNN model images taken from <a href="https://www.geeksforgeeks.org/r-language/recurrent-neural-networks-in-r/">GeeksForGeeks Website</a></p>

                    <h2>Example of sentences generated</h2>
                    <img src={sentences} className="w-100 p-5" alt=""></img>


                    <h1>Project description</h1>
                    <p>
                    This project was initially an assignment for CMPUT 461: Natural Language Processing. Instead of using a RNN to generate sentences, we used an N-gram model
                    to generate them (an older and simpler model before neural networks). I wanted to try the assignment but with a Neural Network and RNNs are great
                    for natural language generation. Compared to the N-gram model, the RNN generated much more grammatically coherent sentences.
                        <br />
                    </p>

                    {/* Buttons that link to earsketch's websites */}
                    <Button className="m-3" href="https://colab.research.google.com/drive/11As5Jjxo612BUy63mA70SPZoTRmoG6ny?usp=sharing">Notebook</Button>
                </div>
            </Collapse>
        </div>
    )
}

export default Project3